import { useContext, useEffect, useState } from "react";
import { RestOrderContext } from "../../../../contexts/restaurantOrder.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
const ROMItem = ({ itemName, menuItem }) => {
  const [subsectionClass, setSubSectionClass] = useState(
    "rom-category-subsection"
  );
  const [correctedItemName, setCorrectedItemName] = useState("");

  const [count, setCount] = useState(0);
  const { restOrderContext, setRestOrderContext } =
    useContext(RestOrderContext);
  useEffect(() => {
    if (Object.keys(restOrderContext).length === 0) {
      setCount(0);
    }
  }, [restOrderContext]);
  useEffect(() => {
    const tempName = itemName.replace("_", " ");
    setCorrectedItemName(tempName);
  }, []);

  useEffect(() => {
    if (menuItem["metadata"] === "item") {
      if (count !== 0) {
        var tempItemTotal = count * menuItem["price"];
        var tempOrderItem = {
          itemCount: count,
          itemTotal: tempItemTotal,
        };
        setRestOrderContext({ ...restOrderContext, [itemName]: tempOrderItem });
      } else {
        var newObject = {};
        Object.keys(restOrderContext).map((index) => {
          if (index !== itemName) {
            newObject = { ...newObject, [index]: restOrderContext[index] };
          }
        });
        setRestOrderContext(newObject);
      }
    }
  }, [count]);

  const handleCount = (type) => {
    if (type === "negative" && count > 0) {
      setCount(count - 1);
    } else if (type === "positive") {
      setCount(count + 1);
    }
  };
  const handleClick = () => {
    if (subsectionClass === "rom-category-subsection") {
      setSubSectionClass("rom-category-subsection-minimize");
    } else {
      setSubSectionClass("rom-category-subsection");
    }
  };
  if (menuItem["metadata"] === "category") {
    return (
      <div className="rom-category-container">
        <div className="rom-category-title">
          <span className="rom-category-title-name">{correctedItemName}</span>
          <span className="rom-category-title-min" onClick={handleClick}>
            {subsectionClass === "rom-category-subsection" ? (
              <FontAwesomeIcon icon={faChevronUp} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )}
          </span>
        </div>
        <div className={subsectionClass}>
          {Object.keys(menuItem).map((index) => {
            if (index !== "metadata") {
              return (
                <ROMItem
                  key={index}
                  itemName={index}
                  menuItem={menuItem[index]}
                />
              );
            }
          })}
        </div>
      </div>
    );
  } else if (menuItem["metadata"] === "item") {
    return (
      <div className="rom-item-container">
        <div className="rom-item-details">
          <span className="rom-item-details-name">{correctedItemName}</span>
        </div>
        <div className="rom-item-count-adjust">
          <button
            className="rom-item-adjust-symbol"
            onClick={() => handleCount("negative")}
          >
            <FontAwesomeIcon icon={faMinus} />
          </button>
          <span className="rom-item-adjust-count">{count}</span>
          <button
            className="rom-item-adjust-symbol"
            onClick={() => handleCount("positive")}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
      </div>
    );
  }
};
export default ROMItem;
